<template>
  <z-dialog
    :model-value="modelValue"
    title="成员资料"
    width="360px"
    append-to-body
    align-center
    destroy-on-close
    @update:model-value="emit('update:modelValue', $event)"
  >
    <div v-if="member" class="message-member-profile">
      <z-avatar
        :size="56"
        :style="{ backgroundColor: memberAvatarColor(member.id) }"
      >
        {{ memberInitial(member.name) }}
      </z-avatar>
      <h3>{{ member.name }}</h3>
      <dl>
        <div>
          <dt>账号</dt>
          <dd>{{ member.username || '—' }}</dd>
        </div>
        <div>
          <dt>邮箱</dt>
          <dd>{{ member.email || '—' }}</dd>
        </div>
      </dl>
    </div>
    <template #footer>
      <z-button @click="emit('update:modelValue', false)">关闭</z-button>
      <z-button
        v-if="canDirect"
        type="primary"
        @click="onDirectChat"
      >
        发消息
      </z-button>
    </template>
  </z-dialog>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import ZAvatar from '@zoryn/components/avatar'
import ZButton from '@zoryn/components/button'
import ZDialog from '@zoryn/components/dialog'
import {
  canDirectChat,
  memberAvatarColor,
  memberInitial,
} from '../utils/conversation-utils'
import type { ConversationMember } from '../types'
import '@zoryn/components/avatar/style'
import '@zoryn/components/button/style'
import '@zoryn/components/dialog/style'

const props = defineProps<{
  modelValue: boolean
  member: ConversationMember | null
}>()

const emit = defineEmits<{
  'update:modelValue': [value: boolean]
  'direct-chat': [member: ConversationMember]
}>()

const canDirect = computed(
  () => props.member != null && canDirectChat(props.member)
)

function onDirectChat() {
  if (!props.member) return
  emit('direct-chat', props.member)
}
</script>
